{
  "point": "ポイント",
  "points": "ポイント",
  "credits": "クレジット",
  "loyaltyCredit": "ロイヤリティクレジット",
  "statusPoints": "ステータスポイント",
  "balancePoints": "利用するポイント",
  "edit": "編集",
  "delete": "削除",
  "copyOf": "{value} のコピー",
  "numberedCopyOf": "{index} ({value}) のコピー",
  "total": "合計",
  "uplift": "アップリフト",
  "approveBtn.label": "OK",
  "cancelBtn.label": "キャンセル",
  "createBtn.label": "作成",
  "saveBtn.label": "保存",
  "searchBtn.label": "検索",
  "updateBtn.label": "更新",
  "applyBtn.label": "適用",
  "addNewPlanBtn.label": "プランの追加",
  "launchPlanBtn.label": "プランの開始",
  "toOverviewBtn.label": "概要に移動",
  "collapseBtn.label": "折りたたむ",
  "extendBtn.label": "詳細を表示 ",
  "updateAndSave.label": "更新して保存",
  "pleaseConfirmBtn.label": "確認",
  "closeBtn.label": "閉じる",
  "resetBtn.label": "リセット",
  "confirmBtn.label": "確認",
  "status.inactive": "無効",
  "status.active": "有効",
  "status.deactivated": "無効化済み",
  "status.scheduled": "スケジュール済み",
  "status.expired": "期限切れ",
  "status.readyToUse": "使用可能",
  "status.readyToLaunch": "開始可能",
  "status.empty": "空",
  "status.activity.pending": "保留中",
  "status.activity.confirmed": "確認済み",
  "status.activity.expired": "期限切れ",
  "status.activity.canceled": "キャンセル済み",
  "status.activity.removed": "削除済み",
  "status.default": "デフォルト",
  "action.promotion": "プロモーション",
  "action.referral": "紹介",
  "action.action": "アクション",
  "tiers.numberOfPurchases.plural.zero": "{number} 回の購入",
  "tiers.numberOfPurchases.plural.one": "{number} 回の購入",
  "tiers.numberOfPurchases.plural.two": "{number} 回の購入",
  "tiers.numberOfPurchases.plural.few": "{number} 回の購入",
  "tiers.numberOfPurchases.plural.many": "{number} 回の購入",
  "tiers.numberOfPurchases.plural.other": "{number} 回の購入",
  "validity.unlimited": "無制限",
  "validity.limitedFromEarn.value.days.plural.zero": "{number} 日間",
  "validity.limitedFromEarn.value.days.plural.one": "{number} 日間",
  "validity.limitedFromEarn.value.days.plural.two": "{number} 日間",
  "validity.limitedFromEarn.value.days.plural.few": "{number} 日間",
  "validity.limitedFromEarn.value.days.plural.many": "{number} 日間",
  "validity.limitedFromEarn.value.days.plural.other": "{number} 日間",
  "validity.limitedFromEarn.value.weeks.plural.zero": "{number} 週間",
  "validity.limitedFromEarn.value.weeks.plural.one": "{number} 週間",
  "validity.limitedFromEarn.value.weeks.plural.two": "{number} 週間",
  "validity.limitedFromEarn.value.weeks.plural.few": "{number} 週間",
  "validity.limitedFromEarn.value.weeks.plural.many": "{number} 週間",
  "validity.limitedFromEarn.value.weeks.plural.other": "{number} 週間",
  "validity.limitedFromEarn.value.months.plural.zero": "{number} カ月間",
  "validity.limitedFromEarn.value.months.plural.one": "{number} カ月間",
  "validity.limitedFromEarn.value.months.plural.two": "{number} カ月間",
  "validity.limitedFromEarn.value.months.plural.few": "{number} カ月間",
  "validity.limitedFromEarn.value.months.plural.many": "{number} カ月間",
  "validity.limitedFromEarn.value.months.plural.other": "{number} カ月間",
  "days": "日",
  "dayInMonth": "日",
  "month": "月",
  "months.1": "1 月",
  "months.2": "2 月",
  "months.3": "3 月",
  "months.4": "4 月",
  "months.5": "5 月",
  "months.6": "6 月",
  "months.7": "7 月",
  "months.8": "8 月",
  "months.9": "9 月",
  "months.10": "10 月",
  "months.11": "11 月",
  "months.12": "12 月",
  "form.missingSettingsAlert": "保存して次のステップに進む前に、必要な情報をすべて入力したか確認してください。",
  "noResults.title": "結果が見つかりません。",
  "noResults.text": "\"{text}\" の検索に一致する結果がありません。",
  "alertContainer.editModeAlert.message": "次のバージョンのロイヤリティプランを編集しています。この新しいバージョンを開始した後に変更が有効になります。 ",
  "alertContainer.liveModeAlert.message.linkText": "詳細情報",
  "alertContainer.liveModeAlert.message": "ロイヤリティ管理から会員層、固定会員特典、追加会員特典を編集するには、\"更新して開始\" を選択してから次のバージョンの編集に切り替えます。{link}",
  "card.isRoadmap.text": "ロードマップ",
  "catalogSelector.tooManyResults.title": "この検索の結果が多すぎます。 ",
  "catalogSelector.tooManyResults.text": "具体的なキーワードで検索を再試行して、結果を絞り込んでください。",
  "catalogSelector.errorAlert": "問題が発生しました。再試行してください。",
  "catalogSelector.searchPlaceholder.byItem": "特定の製品を検索します。",
  "catalogSelector.searchPlaceholder.byCatOrBrand": "プロモーションする特定のブランドまたはカテゴリを選択します。",
  "catalogSelector.checkAllItems.label": "すべて選択",
  "catalogSelector.showAllSelections.label": "選択したアイテムのみ表示する。",
  "catalogSelector.cancelBtn.label": "閉じる",
  "catalogSelector.saveBtn.label": "適用して保存",
  "catalogSelector.brands.plural.zero": "{number} ブランド",
  "catalogSelector.brands.plural.one": "{number} ブランド",
  "catalogSelector.brands.plural.two": "{number} ブランド",
  "catalogSelector.brands.plural.few": "{number} ブランド",
  "catalogSelector.brands.plural.many": "{number} ブランド",
  "catalogSelector.brands.plural.other": "{number} ブランド",
  "catalogSelector.category.plural.zero": "{number} カテゴリ",
  "catalogSelector.category.plural.one": "{number} カテゴリ",
  "catalogSelector.category.plural.two": "{number} カテゴリ",
  "catalogSelector.category.plural.few": "{number} カテゴリ",
  "catalogSelector.category.plural.many": "{number} カテゴリ",
  "catalogSelector.category.plural.other": "{number} カテゴリ",
  "catalogSelector.product.plural.zero": "{number} 製品",
  "catalogSelector.product.plural.one": "{number} 製品",
  "catalogSelector.product.plural.two": "{number} 製品",
  "catalogSelector.product.plural.few": "{number} 製品",
  "catalogSelector.product.plural.many": "{number} 商品",
  "catalogSelector.product.plural.other": "{number} 製品",
  "confirmNavDialog.discardChanges.text": "変更は必ず保存してください。このページを閉じると、保存されていない変更は失われます。",
  "confirmNavDialog.approveBtn.label": "OK",
  "confirmNavDialog.cancelBtn.label": "キャンセル",
  "actionDashboard.overviewLinkText.referral": "紹介アクションに移動",
  "actionDashboard.editLinkText": "プログラムの編集",
  "dashboardOptions.launchedAt": "プログラム開始: ",
  "dashboardOptions.currentlyShowingLabel": "現在表示中:",
  "dashboardOptions.viewLabel": "表示:",
  "masterActions.join.largeText": "ロイヤリティに入会",
  "masterActions.purchases.largeText": "購入",
  "status.inactive.tooltip": "設定は完了していません。",
  "status.inactive.tooltip.proomotionEnded": "このプロモーションは無効のため編集できません。プロモーションをコピーするか、新しいプロモーションを作成することは可能です。",
  "status.inactive.tooltip.connectedToRewardPools": "バウチャープール {name} のステータスは {status} です。",
  "status.inactive.tooltip.invalidPromotionRecurringDates": "プロモーションの日付を確認してください。",
  "status.readyToUse.tooltip.promotion": "プロモーションは使用可能です。メンバーのウォレットにプロモーションを自動的に表示するか、ロイヤリティトークンを使用してキャンペーンエディタでメンバーに追加できます。",
  "status.readyToUse.tooltip.attachable": "アクションは使用可能です。ロイヤリティトークンを使用してキャンペーンエディタからコンタクトに追加できます。",
  "status.active.tooltip.promotion": "このプロモーションは有効で、メンバーに利用可能です。",
  "status.active.tooltip.attachable": "このアクションは有効です。設定を変更できません。このアクションを編集するには、まずアクションを無効にして、指定した有効期限日まで待ってください。アクションをコピーし、そのコピーを編集して新しいアクションとして開始することも可能です。",
  "status.active.tooltip.event": "このアクションは有効です。アクションを会員特典や自動化プログラムと接続できます。",
  "status.deactivated.tooltip.promotion": "このプロモーションを無効にしました。メンバーに利用できなくなりました。",
  "status.deactivated.tooltip.attachable": "このアクションを無効にしました。このアクションを編集または削除するには、指定した有効期限日まで待つ必要があります。アクションをコピーし、そのコピーを編集して新しいアクションとして開始することも可能です。",
  "editorTypePopup.title": "エディタタイプの選択",
  "editorTypePopup.text": "会員限定アクセスのない顧客にはブロックページが表示されます。カスタム HTML ページを作成するか、テンプレートのいずれかを使用できます。",
  "editorTypePopup.options.html.text": "カスタム HTML ページの作成",
  "editorTypePopup.options.template.text": "テンプレートからページを作成",
  "fileInputField.uploadBtn.label": "アップロード",
  "fileInputField.browseBtn.label": "参照",
  "formStepsContainer.nextStep.text": "次のステップ",
  "formStepsContainer.prevStep.text": "前のステップ",
  "iconGallery.title": "ロイヤリティアイコンのギャラリー",
  "iconGallery.deleteDialog.headline": "このアイコンを削除しますか?",
  "iconGallery.deleteDialog.content": "このアイコンを削除すると、メンバーに表示されなくなります。このアイコンがアクションやバウチャーに接続されていないことを確認してください。",
  "iconGallery.uploadResult.successMessage": "正常にアップロードされました。",
  "iconGallery.searchInput.placeholder": "名前でアイコンを検索します。",
  "iconGallery.fileUploader.tooltip": "<h3>アップロード</h3><b>アイコンアップロードの要件:</b></br>ファイル: SVG または PNG</br>形式: 正方形<br>最大の大きさ: 200x200 ピクセル<br>最大ファイルサイズ: 100 KB</br><sub>* 透明な背景を推奨</sub>。",
  "multiLangPopup.defaultNoticeText": "適切な言語設定がない場合、定義した第一言語がデフォルト言語としてメンバーに表示されます。",
  "multiLangPopup.defaultTitle.currency": "通貨換算",
  "multiLangPopup.defaultTitle.language": "言語翻訳",
  "multiMarketSelector.multiSelectField.placeholder": "-- マーケットの選択 --",
  "multiMarketSelector.selectField.placeholder": "-- マーケットの選択 --",
  "multiPlanSelect.label": "ロイヤリティプランの選択 ",
  "preLaunchPopup.conditions.plan.title": "プランの設定",
  "preLaunchPopup.conditions.plan.text": "ロイヤリティプランの設定がすべて適切で、メンバーの条件と一致していることを確認してください。",
  "preLaunchPopup.conditions.tiers.title": "会員層と会員特典",
  "preLaunchPopup.conditions.tiers.text": "すべてのメンバーに会員層が適切に設定されていること、および会員層のコンタクトの分布が戦略と一致していることを確認してください。",
  "preLaunchPopup.conditions.rewards.title": "特典プール",
  "preLaunchPopup.conditions.rewards.text": "すべての回答に十分なバウチャーコードをアップロードしたこと、およびすべてのプールとバウチャーの有効期限が正しく定義されていることを確認してください。",
  "preLaunchPopup.conditions.actions.title": "アクション",
  "preLaunchPopup.conditions.actions.text": "アクションが使用するすべての戦術をカバーしていること、およびデフォルトアクションをすべて有効化したことを確認してください。",
  "preLaunchPopup.title": "ロイヤリティプランを開始しますか?",
  "preLaunchPopup.text": "設定をチェックしてロイヤリティプランが開始可能であることを確認してください。",
  "timeValidityInput.radioLabel.days": "日",
  "timeValidityInput.radioLabel.weeks": "週",
  "timeValidityInput.radioLabel.months": "月",
  "ctaUrl": "CTA URL",
  "ctaText": "CTA テキスト",
  "message": "メッセージ",
  "pageNotFound": "お探しのページは見つからないようです。",
  "externalEventSetup.title": "外部ロイヤリティイベント",
  "externalEventSetup.name.label": "外部イベント名",
  "externalEventSetup.description.label": "説明",
  "externalEventSetup.description.tooltip": "説明は内部向けで、ロイヤリティイベントの管理に役立ちます。",
  "pointsRatesFields.perDescriptor.points": "獲得 (次の単位当たり):",
  "catalog.item.type.category.name": "カテゴリ",
  "catalog.item.type.brand.name": "ブランド",
  "catalog.item.type.item.name": "製品",
  "catalog.item.type.itemId.name": "アイテム ID",
  "exclusiveAccessOffers.options.fixedBenefit.title": "固定会員特典としてのアクセス",
  "exclusiveAccessOffers.options.additionalBenefits.title": "追加会員特典としてのアクセス",
  "exclusiveAccessOffers.options.action.title": "アクション特典としてのアクセス",
  "exclusiveAccessOffers.options.redemption.title": "ポイントのアクセス",
  "exclusiveAccessOffers.options.redemptionForFree.title": "無料のアクセス",
  "accessValidityType.options.unlimited.name": "アクセスの有効期間を無制限にする。",
  "accessValidityType.options.limitedFromEarn.name": "メンバーがアクセスを獲得した時点から期限付きでアクセスが有効になる。",
  "accessValidityType.options.fixedDate.name": "すべてのメンバーに対して事前定義した期間のアクセスを有効にする。",
  "accessValidityType.options.disabled.fixedBenefit.name": "固定会員特典としてのアクセスの利用を無効にする。",
  "accessValidityType.options.disabled.additionalBenefit.name": "追加会員特典としてのアクセスの利用を無効にする。",
  "accessValidityType.options.disabled.reward.name": "アクションの特典としてのアクセスの利用を無効にする。",
  "createOfModify.options.create.name": "オファーの有効化",
  "createOfModify.options.create.tooltip": "新しいオファーを有効にすると、有効なオファールールがリセットされ、選択したすべての会員層のメンバーが定義されたオファー期間に利用できるようになります。",
  "createOfModify.options.create.tooltip2": "新しいオファーを有効にすると、有効なオファー制約がリセットされ、選択したすべての会員層のメンバーが定義されたオファー期間に利用できるようになります。 ",
  "createOfModify.options.modify.name": "有効なオファーの編集",
  "createOfModify.options.modify.tooltip": "有効なオファーを編集しても、このオファーをすでに引き換えたメンバーには変更が適用されません。",
  "exclusiveAccessFormSteps.exclusiveAccessPoolSettings.title": "専用アクセスの設定",
  "exclusiveAccessFormSteps.exclusiveAccessBlockingEditor.title": "ブロックページ",
  "exclusiveAccessFormSteps.redemptionValue.title": "アクセスとオファー",
  "exclusiveAccessFormSteps.EXCLUSIVE_ACCESS_VALIDITY.title": "有効化",
  "activityElementPointsText.loyalty": "{{points_name}}",
  "activityElementPointsText.pointsToSpend": "利用する {{points_name}}",
  "activityElementPointsText.status": "ステータス {{points_name}}",
  "activityElementPointsText.cashback": "キャッシュバック",
  "activityElementPointsText.cashback.name": "{{cashback_name}}",
  "voucherTypeText.one_time": "1 回限りのバウチャー",
  "voucherTypeText.yearly": "複数回利用できるバウチャー",
  "exclusiveAccessTypeText.permanent": "永続会員限定アクセス",
  "exclusiveAccessTypeText.limitedTerm": "期限付きの会員限定アクセス",
  "mainTabs.dashboard.title": "ダッシュボード",
  "mainTabs.actions.title": "アクション",
  "mainTabs.rewards.title": "特典",
  "mainTabs.tiers.title": "会員層",
  "mainTabs.loyaltyWallet.title": "ロイヤリティウォレット",
  "mainTabs.memberProfiles.title": "メンバープロファイル",
  "mainTabs.externalEvents.title": "外部イベント",
  "mainTabs.planSettings.title": "プランの設定",
  "mainTabs.vouchers.title": "バウチャー",
  "mainTabs.exclusiveAccesss.title": "会員限定アクセス",
  "mainTabs.loyaltyManagement.title": "ロイヤリティ管理",
  "mainTabs.security.title": "ロイヤリティ設定",
  "actionTabs.purchases.title": "購入",
  "actionTabs.promotions.title": "プロモーション",
  "actionTabs.engagements.title": "エンゲージメント",
  "actionTabs.events.title": "イベント",
  "actionTabs.referral.title": "紹介",
  "actionTabs.join.title": "ロイヤリティに入会",
  "tierTabs.tiers.title": "会員層",
  "tierTabs.fixedBenefits.title": "固定会員特典",
  "tierTabs.additionalBenefits.title": "追加会員特典",
  "tierTabs.contactDistribution.title": "分布グラフ",
  "managementTabs.accountSettings.title": "アカウント設定",
  "managementTabs.languageAndCurrency.title": "言語と通貨",
  "managementTabs.planSettings.title": "プラン設定",
  "managementTabs.cashbackSettings.title": "キャッシュバック設定",
  "managementTabs.membershipSettings.title": "メンバーシップ設定",
  "managementTabs.updateAndLaunch.title": "更新して開始",
  "onboardingTabs.accountSettings.title": "プランの作成",
  "onboardingTabs.activation.title": "有効化",
  "customerCalcPeriod.options.1.name": "過去 30 日間",
  "customerCalcPeriod.options.2.name": "過去 60 日間",
  "customerCalcPeriod.options.3.name": "過去 90 日間",
  "customerCalcPeriod.options.6.name": "過去 6 カ月",
  "customerCalcPeriod.options.12.name": "過去 12 カ月",
  "planType.options.points.name": "ポイントと特典引き換え",
  "planType.options.points_and_benefits.name": "ポイントと会員特典",
  "planType.options.spend.name": "利用と会員特典",
  "planType.options.points.tooltip": "単一または複数の会員層およびポイント特典引き換えのあるポイントベースプラン。",
  "planType.options.points_and_benefits.tooltip": "複数の会員層および会員特典があり、ポイント特典引き換えのないポイントベースプラン。",
  "planType.options.spend.tooltip": "単一または複数の会員層および会員特典があり、ポイントはないが、キャッシュバックオプションルールがある利用ベースプラン。利用ベースプランで管理される通貨は 1 つのみです。複数の通貨を管理している場合は、通貨ごとに別のプランを管理する必要があります。",
  "pointsAllocatopmDelay.options.1.name": "24 時間",
  "pointsAllocatopmDelay.options.2.name": "48 時間",
  "pointsAllocatopmDelay.options.3.name": "72 時間",
  "pointsAllocatopmDelay.options.7.name": "7 日間",
  "pointsAllocatopmDelay.options.14.name": "14 日間",
  "pointsAllocatopmDelay.options.21.name": "21 日間",
  "pointsAllocatopmDelay.options.30.name": "30 日間",
  "pointsAllocatopmDelay.options.40.name": "40 日間",
  "tierCalculationType.options.endOfYear.name": " 会員層計算を [X 年] ごとの 12 月 31 日に実施する。",
  "tierCalculationType.options.endOfYear.tooltip": "会員層は [X 年] ごとの指定日に計算されます。上位の会員層にアップグレードするメンバーは、会員層のステータスを定義された期間維持します。",
  "tierCalculationType.options.afterJoin.name": "会員層計算をメンバーが会員層に入った日付から [X カ月後] に実施する。",
  "tierCalculationType.options.afterJoin.tooltip": "会員層の計算日はメンバーの各会員層の進捗状況に応じて異なる場合があります。上位の会員層にアップグレードするメンバーは、少なくとも定義された期間はその会員層のステータスを維持します。",
  "tierCalculationType.options.endOfYear.spend.tooltip": "会員層が計算されると、ロイヤリティクレジットはリセットされますが、次の計算までメンバーのステータスは維持されます。",
  "tierCalculationType.options.noDropout.name": "会員層を計算しない。メンバーは会員層にとどまる要件を満たす必要はない。",
  "tierCalculationType.options.noDropout.tooltip": "ポイントは会員層のアップグレートのためだけに収集されます。",
  "statusPointsExpirationType.options.tierCalc.name": "ステータスポイントは会員層計算日に期限が切れてリセットされる。",
  "statusPointsExpirationType.options.tierCalc.tooltip": "ポイントは計算されるとリセットされますが、次の計算までメンバーのステータスは維持されます。",
  "statusPointsExpirationType.options.fromEarn.name": "ステータスポイントはメンバーがポイントを獲得した日から [X カ月] ごとに期限が切れてリセットされる。",
  "statusPointsExpirationType.options.fromEarn.tooltip": "会員層計算では、その日に有効なポイントのみが計算されます。メンバーはステータスを維持するか、下位の会員層にダウングレードします。",
  "statusPointsExpirationType.options.never.name": "ステータスポイントは期限切れにならない。",
  "loyaltyCreditExpirationType.options.tiersCalc.name": "ロイヤリティクレジットは会員層計算日に期限が切れてリセットされる。",
  "loyaltyCreditExpirationType.options.tiersCalc.tooltip": "ロイヤリティクレジットは計算されるとリセットされますが、次の計算までメンバーのステータスは維持されます。",
  "loyaltyCreditExpirationType.options.fromEarn.name": "ロイヤリティクレジットはメンバーがクレジットを獲得した日から [X カ月] ごとに期限が切れてリセットされる。",
  "loyaltyCreditExpirationType.options.fromEarn.tooltip": "会員層計算では、その日に有効なロイヤリティクレジットのみが計算されます。メンバーはステータスを維持するか、下位の会員層にダウングレードします。",
  "optIn.options.invitation.name": "すべてのコンタクトをロイヤリティプランに入会するよう招待する。",
  "optIn.options.automatic.name": "すべてのコンタクトが自動的にロイヤリティメンバーになる。",
  "historicalBalancePoints.options.keep.name": "利用ポイントで特典を与える。",
  "historicalBalancePoints.options.keep.tooltip": "このオプションは、特典のポイントを引き換えるメンバーにインセンティブを与えます。",
  "historicalBalancePoints.options.remove.name": "利用ポイントで特典を与えない。",
  "historicalBalancePoints.options.remove.tooltip": "利用ポイントはリセットされ、メンバーは引き換えできるポイントを新たに獲得する必要があります。",
  "currencyIdentifierSigh.options.symbol.name": "通貨記号",
  "currencyIdentifierSigh.options.symbol.tooltip": "例: $500",
  "currencyIdentifierSigh.options.code.name": "ISO 通貨コード",
  "currencyIdentifierSigh.options.code.tooltip": "例: 500USD",
  "currencyIdentifierSigh.options.none.name": "ID なし",
  "formStepRewards.options.poolSettings.title": "プール設定",
  "formStepRewards.options.uploadFile.title": "ファイルのアップロード",
  "formStepRewards.options.redemptionValue.title": "オファー設定",
  "formStepRewards.options.validity.title": "有効期間",
  "specialTiers.redemptopmSettings.all.name": "すべての会員層に同じ設定を使用します。個々の会員層の値は上書きされます。",
  "voucherValidityType.options.unlimited.name": "バウチャーの有効期間を無制限にする。",
  "voucherValidityType.options.limitedFromEarn.name": "メンバーがバウチャーを獲得した時点から期限付きでバウチャーが有効になる。",
  "voucherValidityType.options.fixedDate.name": "すべてのメンバーに対して事前定義した期間にバウチャーを有効にする。",
  "redemptionLimit.options.noLimit.name": "メンバーに対して定期的にこのオファーを自動表示する。",
  "redemptionLimit.options.noLimit.tooltip": "会員層の切り替えを有効にした場合、特典引き換えの制限なしでロイヤリティウォレットに特典引き換えのオファーが表示されます。",
  "redemptionLimit.options.limitMember.name": "このオファーに対して定義された期間中に各メンバーがバウチャーを引き換えるできる回数を選択する。",
  "exclusiveAccessExclusivityType.options.name.fixed": "永続専用アクセス",
  "exclusiveAccessExclusivityType.options.name.limitedTerm": "期間限定の専用アクセス",
  "exclusiveAccessExclusivityType.options.name.limited": "限定専用アクセス",
  "editorContentTextDefaultValues.tag": "会員限定アクセス",
  "editorContentTextDefaultValues.firstHeader": "<strong>アーリーブラックフライデー</strong>",
  "editorContentTextDefaultValues.secondHeader": "<strong>セール</strong>",
  "editorContentTextDefaultValues.middleText": "大切なメンバーの皆さまだけが利用できる会員限定ブラックフライデー特典をお見逃しなく。今すぐロイヤリティプランにご入会ください。",
  "editorContentTextDefaultValues.actionTopText": "まだメンバーになっていない場合は、ロイヤリティプランに入会して特典の獲得を始めましょう。",
  "editorContentTextDefaultValues.leftButton": "ロイヤリティに入会",
  "editorContentTextDefaultValues.rightButton": "今は入会しない",
  "editorContentTextDefaultValues.actionBottomText": "<span>メンバーになっている場合は<u>サインイン</u></span>",
  "editorContentTextDefaultValues.middleText.mobile": "大切なお客様だけにお届けする会員限定特典をお見逃しなく。今すぐロイヤリティプランにご入会ください。",
  "editorContentTextDefaultValues.actionTopText.mobile": "まだメンバーになっていない場合は、ロイヤリティプログラムに入りましょう。",
  "accessUrlType.options.exactUrl.name": "このページをブロックして会員限定アクセスをオファーする",
  "accessUrlType.options.startsWithUrl.name": "この URL で始まるすべてのページをブロックして会員限定アクセスをオファーする",
  "formStepsContainer.tierSettings.title": "会員層設定",
  "formStepsContainer.purchaseBenefits.title": "購入特典",
  "formStepsContainer.visibility.title": "表示",
  "tierDropout.options.yes.name": "計算する。会員層計算でメンバーがこの会員層にとどまるには要件を満たす必要がある。",
  "tierDropout.options.no.name": "計算しない。この会員層を失うシナリオはない。",
  "fixedBenfitType.options.oneTimeVoucher.name": "1 回限りのバウチャー",
  "fixedBenfitType.options.fixedYearlyVoucher.name": "固定年間バウチャー (複数使用コードが必要)",
  "fixedBenfitType.options.eventAction.name": "イベント",
  "fixedBenfitType.options.exclusiveAccess.name": "会員限定アクセス",
  "fixedBenfitType.options.custom.name": "カスタム (ユーザが独自に提供)",
  "fixedBenfitType.options.fixedYearlyVoucher.additional.name": "複数回使用できるバウチャー (複数使用コードが必要)",
  "tierTypeOptions.regular.name": "ポイントベース",
  "tierTypeOptions.invite.name": "招待のみ",
  "tierTypeOptions.invite.tooltip.learnMoreLinkText": "詳細情報",
  "tierTypeOptions.invite.tooltip": "招待されたメンバーまたは支払いを行っているメンバーのみが会員層に所属できます。支払いとメンバーシップはご自身で管理してください。メンバーをこの会員層に追加するには、ロイヤリティ API またはメンバープロファイルを使用します。{learnMoreLink}。",
  "tierTypeOptions.spend.name": "利用ベース",
  "exclusiveAccess.cardLabels.permanent": "永続",
  "exclusiveAccess.cardLabels.limtedTerm": "期間限定",
  "cards.filterBar.moreFiltersButton": "その他のフィルタ",
  "catalogSelector.selected.single": "{items} を選択しました",
  "catalogSelector.selected.multiple": "{items} と {lastItems} を選択しました",
  "iconGallery.uploadResult.failMessage": "アップロード中に問題が発生しました。ファイルが指定の要件を満たしていることを確認してください。\n{showFileList,select,true{{failed} out of {total} failed: {failedDetails}} other{{failedDetails}}} ",
  "pointsRatesFields.perDescriptor.spend": "それぞれの",
  "activityElementMultiuplyPointsText.double": "ダブル",
  "activityElementMultiuplyPointsText.triple": "トリプル"
}
